export default "__VITE_ASSET__c432dadb__"